/** Time gutter width — default desktop; narrow screens use getTeamCalGridMetrics */
export const GUTTER_WIDTH_PX = 76;

/** Default employee column width — narrow screens use getTeamCalGridMetrics */
export const COLUMN_WIDTH_PX = 128;

/** Extra columns rendered outside the viewport on each side */
export const COLUMN_OVERSCAN = 3;

/**
 * Tighter gutter + columns on small viewports so more staff fits and touch scroll is usable.
 * @param {number} scrollViewportWidth clientWidth of horizontal scroll container (0 before measure)
 */
export function getTeamCalGridMetrics(scrollViewportWidth) {
  const w =
    scrollViewportWidth > 0
      ? scrollViewportWidth
      : typeof window !== 'undefined'
        ? window.innerWidth
        : 1024;
  if (w < 360) {
    return { gutterWidthPx: 54, columnWidthPx: 90 };
  }
  if (w < 420) {
    return { gutterWidthPx: 58, columnWidthPx: 96 };
  }
  if (w < 520) {
    return { gutterWidthPx: 64, columnWidthPx: 104 };
  }
  if (w < 640) {
    return { gutterWidthPx: 70, columnWidthPx: 118 };
  }
  return { gutterWidthPx: GUTTER_WIDTH_PX, columnWidthPx: COLUMN_WIDTH_PX };
}
